(() => {
  const root = document.documentElement;
  const system = matchMedia('(prefers-color-scheme: dark)');
  let manual = false;
  try { manual = ['light', 'dark'].includes(localStorage.getItem('techers-appearance')); } catch (_) {}
  const sync = () => {
    const dark = root.dataset.appearance === 'dark';
    document.querySelectorAll('[data-appearance-toggle]').forEach(button => {
      button.hidden = false;
      button.setAttribute('aria-pressed', String(dark));
      const label = button.querySelector('.techers-appearance-label');
      if (label) label.textContent = dark ? button.dataset.lightLabel : button.dataset.darkLabel;
    });
    const meta = document.querySelector('meta[name="theme-color"]');
    if (meta) meta.content = dark ? '#10151e' : '#ffffff';
  };
  const apply = mode => {
    root.dataset.appearance = mode;
    root.style.colorScheme = mode;
    sync();
  };
  document.addEventListener('click', event => {
    if (!event.target.closest('[data-appearance-toggle]')) return;
    const mode = root.dataset.appearance === 'dark' ? 'light' : 'dark';
    manual = true;
    try { localStorage.setItem('techers-appearance', mode); } catch (_) {}
    apply(mode);
  });
  system.addEventListener('change', event => { if (!manual) apply(event.matches ? 'dark' : 'light'); });
  window.addEventListener('storage', event => {
    if (event.key !== 'techers-appearance') return;
    manual = ['light', 'dark'].includes(event.newValue);
    apply(manual ? event.newValue : (system.matches ? 'dark' : 'light'));
  });
  document.addEventListener('shopify:section:load', sync);
  sync();
})();
